import { defaultWorkingDays } from './calendarTypes';
export const initialUserSettingsState = {
    userId: '',
    userName: 'defaultUser',
    totalHolidays: 0,
    approvedHolidays: 0,
    pendingHolidays: 0,
    remainingHolidays: 0,
    managerEmail: '',
    workingDays: defaultWorkingDays,
    entitlement: 0,
    entitlementSetOn: null,
    isSetup: false,
    askToSetupYear: false,
    holidayYearStart: '',
    holidayYearEnd: '',
    timeAdded: new Date(),
    start: new Date(),
    end: new Date(),
    knownAsName: '',
    managerName: '',
    remaining: 0,
    doNotShowSetupYearDialog: false,
    countryCode: '00',
    regionCode: '',
    initialUserDataLoaded: false,
    initialHolidayDataLoaded: false,
    initialSetupDone: true,
    refresh: 0,
    initialSetupDoneAt: new Date(),
    daysBookedUsingAbdoo: 0,
    managerSharingDataOption: undefined,
    isManager: false,
};
export var ManagerDataSharingOption;
(function (ManagerDataSharingOption) {
    ManagerDataSharingOption[ManagerDataSharingOption["AllHistoricData"] = 0] = "AllHistoricData";
    ManagerDataSharingOption[ManagerDataSharingOption["CurrentEntitlementYear"] = 1] = "CurrentEntitlementYear";
})(ManagerDataSharingOption || (ManagerDataSharingOption = {}));
export const initialManagerState = {
    knownAsName: '',
    managerName: '',
    managerEmail: '',
    requestManager: true,
    managerSharingDataOption: undefined,
};
export const initialUserState = {
    userId: '',
    email: '',
    pendingRequests: 0,
};
